<template>
  <div class="presupuesto-pedido-desde-productos-page">
    <v-container fluid class="page-container-full">
      <v-card class="elevation-6 card-full-width">
        <div class="d-flex align-center pa-4 page-header-bar" style="flex-shrink: 0">
          <v-btn icon dark @click="goBack">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h2 class="ml-3 mb-0">{{ pageTitle }}</h2>
        </div>
        <v-card-text v-if="!depositoIdSeleccionado" class="pa-2" style="flex-shrink: 0; flex-grow: 0">
          <v-alert type="warning" dense class="mb-0">
            {{ $t('producto.modals.presupuestoPedido.errorDeposito') }}
          </v-alert>
        </v-card-text>
        <v-card-text class="form-area pa-2">
          <presupuesto-pedido-form
            ref="formRef"
            :initial-items="basketItems"
            @update:tipoDocumento="tipoDocumento = $event"
            @total-change="totalInfo = $event"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions class="footer-actions px-4">
          <v-btn text color="grey darken-1" @click="goBack">
            <v-icon left small>mdi-close</v-icon>
            {{ $t('producto.modals.presupuestoPedido.cancelar') }}
          </v-btn>
          <v-spacer />
          <div style="display:flex;flex-direction:row;align-items:center">
            <template v-if="totalInfo.descuento > 0 || totalInfo.recargo > 0">
              <div style="display:flex;flex-direction:column;align-items:flex-end;gap:4px">
                <div style="display:flex;gap:4px">
                  <v-chip v-if="totalInfo.descuento > 0" small color="green darken-1" dark>-{{ totalInfo.descuento }}%</v-chip>
                  <v-chip v-if="totalInfo.recargo > 0" small color="red darken-1" dark>+{{ totalInfo.recargo }}%</v-chip>
                </div>
                <span style="font-size:0.92rem;color:#b0bec5;text-decoration:line-through">${{ totalInfo.subtotal }}</span>
              </div>
              <v-icon color="grey lighten-1" style="margin:0 8px">mdi-arrow-right</v-icon>
            </template>
            <div style="display:flex;flex-direction:column;align-items:center;line-height:1.3">
              <span style="font-size:0.68rem;text-transform:uppercase;letter-spacing:0.6px;color:#90a4ae;font-weight:600">Total a Pagar</span>
              <span style="font-size:1.9rem;font-weight:800;color:#1976d2;letter-spacing:-0.5px;line-height:1.1">${{ totalInfo.total }}</span>
            </div>
          </div>
          <v-spacer />
          <v-btn
            color="primary"
            :disabled="!canCreate"
            :loading="loading"
            depressed
            @click="create"
          >
            <v-icon left small>mdi-check</v-icon>
            {{ $t('producto.modals.presupuestoPedido.crear') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { getBasketFromStorage, clearBasketStorage } from "../../utils/presupuestoPedidoBasket";
import UserConfigurationProvider from "../../../user-configuration/providers/UserConfigurationProvider";
import PresupuestoProvider from "../../providers/PresupuestoProvider";
import OrdenVentaProvider from "../../providers/OrdenVentaProvider";
import PresupuestoPedidoForm from "./PresupuestoPedidoForm.vue";

export default {
  name: "PresupuestoPedidoDesdeProductosPage",
  components: { PresupuestoPedidoForm },
  data() {
    return {
      basketItems: [],
      tipoDocumento: "presupuesto",
      depositoIdSeleccionado: null,
      loading: false,
      totalInfo: { total: "0.00", subtotal: "0.00", descuento: 0, recargo: 0 },
    };
  },
  computed: {
    pageTitle() {
      return this.tipoDocumento === "pedido"
        ? "Creando Orden de Venta"
        : "Creando Presupuesto";
    },
    canCreate() {
      if (!this.$refs.formRef) return false;
      return this.depositoIdSeleccionado && this.$refs.formRef.valid();
    },
  },
  created() {
    this.basketItems = getBasketFromStorage();
    if (!this.basketItems || this.basketItems.length === 0) {
      this.$router.replace("/producto-management");
      return;
    }
    this.loadDeposito();
  },
  methods: {
    async loadDeposito() {
      try {
        let depositoId = UserConfigurationProvider.getDepositoIdFromCache();
        if (!depositoId) {
          const r = await UserConfigurationProvider.getUserConfiguration(true);
          const config = r.data && r.data.userConfigurationGet;
          depositoId =
            (config && config.depositoIdSeleccionado) ||
            (config && config.deposito && config.deposito.id) ||
            null;
        }
        this.depositoIdSeleccionado = depositoId;
      } catch (e) {
        console.error(e);
        this.depositoIdSeleccionado = null;
      }
    },
    goBack() {
      this.$router.push("/producto-management");
    },
    async create() {
      const form = this.$refs.formRef;
      if (!form || !form.valid() || !this.depositoIdSeleccionado) return;
      this.loading = true;
      try {
        const payload = form.getPayload();
        const { tipoDocumento, clienteId, vendedorId, items, descuento, recargo, listaPreciosVentaId } = payload;
        const itemsWithQty = (items || []).filter((i) => Number(i.cantidad) >= 1);
        if (tipoDocumento === "presupuesto") {
          const input = {
            clienteId,
            depositoId: this.depositoIdSeleccionado,
            vendedorId: vendedorId || undefined,
            descuento,
            recargo,
            listaPreciosVentaId: listaPreciosVentaId || undefined,
            items: itemsWithQty.map((i) => ({
              producto: (i.producto && (i.producto.id || i.producto._id)) || (i.product && (i.product.id || i.product._id)),
              cantidad: Number(i.cantidad) || 1,
            })),
          };
          const r = await PresupuestoProvider.createPresupuesto(input);
          if (r.data && r.data.presupuestoCreate) {
            clearBasketStorage();
            this.$router.push("/presupuestos");
          }
        } else {
          const pedidoItems = itemsWithQty.map((i) => {
            const p = i.producto || i.product;
            const cantidad = Number(i.cantidad) || 1;
            const precioUnitario = (p && p.precio != null) ? Number(p.precio) : (p && p.precioVenta != null ? Number(p.precioVenta) : 0);
            const precioTotal = Math.round(cantidad * precioUnitario * 100) / 100;
            return {
              producto: (p && (p.id || p._id)) || null,
              cantidad,
              precioUnitario,
              precioTotal,
              productoNombre: (p && p.nombre) || null,
              productoMarca: (p && p.marca && p.marca.nombre) || null,
              productoModelo: (p && p.modelo && p.modelo.nombre) || null,
              productoTamanio: (p && p.tamanio && p.tamanio.tamanio) || null,
              productoIVA: (p && p.ivaPorcentaje != null) ? p.ivaPorcentaje : 0,
            };
          });
          const input = {
            clienteId,
            depositoId: this.depositoIdSeleccionado,
            vendedorId: vendedorId || undefined,
            listaPreciosVentaId: listaPreciosVentaId || undefined,
            descuento,
            recargo,
            items: pedidoItems,
          };
          const r = await OrdenVentaProvider.createOrdenVenta(input);
          if (r.data && r.data.ordenVentaCreate) {
            clearBasketStorage();
            this.$router.push("/ordenes-venta");
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.presupuesto-pedido-desde-productos-page {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.presupuesto-pedido-desde-productos-page >>> .page-container-full {
  max-width: 100% !important;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.presupuesto-pedido-desde-productos-page >>> .card-full-width {
  width: 100%;
  height: calc(100vh - 64px);
  max-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.page-header-bar {
  background: #1976d2;
  color: white;
}
.form-area {
  flex: 1 1 0 !important;
  min-height: 0 !important;
  overflow: hidden !important;
}
.footer-actions {
  flex-shrink: 0;
  min-height: 56px;
}
.footer-total-badge {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.3;
}
.footer-total-label {
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #90a4ae;
  font-weight: 600;
}
.footer-total-amount {
  font-size: 1.9rem;
  font-weight: 800;
  color: #1976d2;
  letter-spacing: -0.5px;
  line-height: 1.1;
}
</style>
